module.exports = __webpack_public_path__ + "img/icon-relabel-en.27dc0afa.svg";